import script from "./RewardCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardCard.vue?vue&type=script&setup=true&lang=js"

import "./RewardCard.vue?vue&type=style&index=0&id=3c43694f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c43694f"]])

export default __exports__